import * as React from "react";
import { useState } from "react";
import { Box,} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';

// Import the CSS file
import '../css/DragDropComponent.css';

const DragDropFile = ({onImportFile}) => {
  const [dragActive, setDragActive] = React.useState(false);
  // ref
  const inputRef = React.useRef(null);
  
  const handleFile = async function (files) {
    try {
      setLoading(true);
      const file = files[0];

      // Create a FormData object and append the file to it
      const formData = new FormData();
      formData.append("file", file);

      // Call the onImportFile function and wait for it to complete
      await onImportFile(formData);

      // Once the task is completed, set loading to false
      setLoading(false);
      handleNotification("Upload file successful", "#2e7d31");
    } catch (error) {
      // Handle any errors
      setLoading(false);
      console.error(error);
      handleNotification("Error uploading file", "#ff0000");
    }
  };

  const [loading, setLoading] = useState(false);

  // handle drag events
  const handleDrag = function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  
  // triggers when file is dropped
  const handleDrop = function(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files);
    }
  };
  
  // triggers when file is selected with click
  const handleChange = function(e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files);
    }
  };
  
// triggers the input when the button is clicked
  const onButtonClick = () => {
    inputRef.current.click();
  };

  const [state, setState] = useState({
    open: false,
    vertical: 'bottom',
    horizontal: 'right',
    background:"#2e7d31"
  });
  const { vertical, horizontal, open, mess, background} = state;

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleNotification = (mess, background) =>{
    setState({ ...state, mess, background, open:true});

  }

  return (
    <>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
          <CircularProgress />
        </Box>
      ) : (
        <form
          id="form-file-upload"
          onDragEnter={handleDrag}
          onSubmit={(e) => e.preventDefault()}
        >
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            message={mess}
            onClose={handleClose}
            key={vertical + horizontal}
            sx={{"& .MuiSnackbarContent-root": {
              backgroundColor: background,
              color:"white",
              fontWeight:"bold"
            } }}
            autoHideDuration={5000}
          />
          <input
            ref={inputRef}
            type="file"
            id="input-file-upload"
            onChange={handleChange}
            accept=".txt"
          />
          <label
            id="label-file-upload"
            htmlFor="input-file-upload"
            className={dragActive ? "drag-active" : ""}
          >
            <div>
              <p>Drag and drop your file here or</p>
              <button className="upload-button" onClick={onButtonClick}>
                Upload a file
              </button>
            </div>
          </label>
          {dragActive && (
            <div
              id="drag-file-element"
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
              onDrop={handleDrop}
            ></div>
          )}
        </form>
      )}
    </>
  );
};

export default DragDropFile;
